import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_Textletter_Interface, Textletter_Interface } from 'src/app/Interface/Textletter_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { TextletterService } from 'src/app/Service/Textletter/Textletter.service';

@Component({
  selector: 'app-TextletterList',
  templateUrl: './TextletterList.component.html',
  styleUrls: ['./TextletterList.component.scss']
})
export class TextletterListComponent implements OnInit {
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private Textletter_Service:TextletterService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Textletter:Array<Textletter_Interface>=[]
  Data_Seleted_Delete:Textletter_Interface=Empty_Textletter_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(43).subscribe(
      data=>{
        this.ReadData_Textletter()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Textletter(){
    this.Procssing=true
    this.Textletter_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Textletter=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(){
    this.modalRef_Delete.hide()
    this.Textletter_Service.DeleteText_letter(this.Data_Seleted_Delete.id).subscribe(
      data=>{
        if(this.Data_Seleted_Delete.del==false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")

        this.ReadData_Textletter()
      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
